import React from 'react'
import HomePage from 'pages/HomePage/HomePage'

const RouteHandler: React.FC = () => {
  return <HomePage />
}

export default RouteHandler
